/**
 * INFINITY LIFE 2.0 — Top Header Component
 */

import { store } from '../state.js';
import { showToast } from '../api.js';
import { promptPWAInstall } from '../pwa.js';

export function renderHeader() {
  const { user, activeMode, isOnline, pendingSyncCount, unreadNotificationsCount, isPwaInstallable } = store.get();

  const modes = [
    { id: 'my_day', label: 'Meu Dia', icon: '☀️' },
    { id: 'work', label: 'Trabalho', icon: '💼' },
    { id: 'health', label: 'Saúde', icon: '❤️' },
    { id: 'study', label: 'Estudos', icon: '📚' },
    { id: 'finance', label: 'Finanças', icon: '💰' },
    { id: 'focus', label: 'Foco', icon: '🎯' },
    { id: 'weekly_review', label: 'Revisão', icon: '📊' },
  ];

  return `
    <header class="top-header">
      <div class="header-left">
        <div class="search-box">
          <span style="color: var(--text-muted); font-size: 0.9rem;">🔍</span>
          <input type="text" id="global-search" placeholder="Buscar tarefas, compromissos ou projetos (Pressione /)..." />
        </div>

        <div class="mode-selector">
          ${modes.map((m) => `
            <button class="mode-btn ${activeMode === m.id ? 'active' : ''}" data-mode="${m.id}" title="${m.label}">
              <span>${m.icon}</span> <span>${m.label}</span>
            </button>
          `).join('')}
        </div>
      </div>

      <div class="header-right">
        <!-- Online / Offline Status -->
        <div class="status-pill ${isOnline ? 'online' : 'offline'}" title="${isOnline ? 'Conectado ao servidor' : 'Modo offline seguro'}">
          <span class="dot"></span>
          <span>${isOnline ? 'Online' : `Offline ${pendingSyncCount > 0 ? `(${pendingSyncCount})` : ''}`}</span>
        </div>

        <!-- PWA Install Button -->
        <button class="btn-secondary" id="btn-pwa-install" style="${isPwaInstallable ? '' : 'display:none;'} font-size: 0.8rem; padding: 6px 12px;">
          <span>📲</span> <span>Instalar App</span>
        </button>

        <!-- Quick Add Button -->
        <button class="btn-primary" id="btn-header-add" title="Criar Nova Tarefa">
          <span>＋</span> <span>Nova Tarefa</span>
        </button>

        <!-- Notification Bell -->
        <button class="btn-icon" id="btn-header-notifications" title="Central de Notificações">
          <span style="font-size: 1.1rem;">🔔</span>
          ${unreadNotificationsCount > 0 ? `<span class="badge-count">${unreadNotificationsCount}</span>` : ''}
        </button>

        <!-- User Profile Avatar / Login -->
        ${user ? `
          <button class="avatar-btn" id="btn-header-profile" title="Meu Perfil">
            ${user.avatar_url ? `
              <img src="${user.avatar_url}" alt="${user.name}" class="avatar-img" />
            ` : `
              <div class="avatar-img">${(user.name || 'U').charAt(0).toUpperCase()}</div>
            `}
            <span class="avatar-name">${(user.name || '').split(' ')[0]}</span>
          </button>
        ` : `
          <button class="btn-secondary" id="btn-header-login">
            <span>🔑</span> <span>Entrar</span>
          </button>
        `}
      </div>
    </header>
  `;
}

export function attachHeaderEvents(container) {
  // Mode selection
  container.querySelectorAll('.mode-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const mode = btn.dataset.mode;
      store.setMode(mode);

      if (mode === 'work') {
        store.setView('business');
        showToast('💼 Modo Trabalho & Clientes Ativado', 'info');
      } else if (mode === 'weekly_review') {
        store.setView('business');
        showToast('📊 Modo Revisão de Expediente Ativado', 'info');
      } else {
        store.setView('my-day');
        if (mode === 'health') showToast('❤️ Modo Saúde & Hidratação Ativado', 'info');
        else if (mode === 'focus') showToast('🎯 Modo Hiperfoco & Pomodoro Ativado', 'info');
        else if (mode === 'finance') showToast('💰 Modo Finanças & Caixa Ativado', 'info');
        else if (mode === 'study') showToast('📚 Modo Estudos & Conhecimento Ativado', 'info');
        else if (mode === 'my_day') showToast('☀️ Visão Geral do Meu Dia Ativada', 'info');
      }
    });
  });

  // PWA Install
  const installBtn = container.querySelector('#btn-pwa-install');
  if (installBtn) {
    installBtn.addEventListener('click', () => promptPWAInstall());
  }

  // Quick Add
  const addBtn = container.querySelector('#btn-header-add');
  if (addBtn) {
    addBtn.addEventListener('click', () => store.openTaskModal());
  }

  // Notifications
  const notifBtn = container.querySelector('#btn-header-notifications');
  if (notifBtn) {
    notifBtn.addEventListener('click', () => store.toggleModal('notifications'));
  }

  // Profile / Login
  const profileBtn = container.querySelector('#btn-header-profile') || container.querySelector('#btn-header-login');
  if (profileBtn) {
    profileBtn.addEventListener('click', () => store.toggleModal('auth'));
  }

  // Global search shortcut (Press '/')
  const searchInput = container.querySelector('#global-search');
  if (searchInput) {
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const query = searchInput.value.trim();
        if (query) {
          store.setView('agenda');
          window.dispatchEvent(new CustomEvent('infinity:search', { detail: query }));
        }
      }
    });
  }
}
